<template>
    <div>
        <div class="module">
            <header class="module__header">
                <h1>Sorry!</h1>
            </header>

            <section class="module__body">We were unable to figure out where to put you.</section>
        </div>
    </div>
</template>
